/** Код единицы измерения → подпись (как в 1С: м, шт, кг …). */
export const UNIT_OPTIONS: { value: string; label: string }[] = [
  { value: 'm', label: 'м (метры)' },
  { value: 'cm', label: 'см' },
  { value: 'mm', label: 'мм' },
  { value: 'kg', label: 'кг' },
  { value: 'g', label: 'г' },
  { value: 't', label: 'т' },
  { value: 'l', label: 'л' },
  { value: 'ml', label: 'мл' },
  { value: 'pcs', label: 'шт' },
  { value: 'pack', label: 'упак.' },
  { value: 'roll', label: 'рулон' },
  { value: 'batch', label: 'пач.' },
  { value: 'sqm', label: 'м²' },
  /** Услуга / работа: в комплектации цена × количество, как у материалов */
  { value: 'labor', label: 'работа' },
]

export function unitLabel(code: string): string {
  return UNIT_OPTIONS.find((u) => u.value === code)?.label ?? code
}
